import './App.css';
import './Assets/Css/theme.scss';
import { Route, Routes, useLocation, useNavigate } from 'react-router';
import Landing from './Components/Landing';
import Login from './Components/Login';
import Dashboard from './Components/Dashboard';
import DashboardLayout from './Components/Layouts/dashboardLayout';
import EmailList from './Components/Email/emailList';
import EyetestList from './Components/Eyetest/eyetestList';
import { useEffect, useState } from 'react';
import NotFound from './Components/NotFound';
import PatientList from './Components/Patient/patientList';
import EyeTestAdd from './Components/Eyetest/eyeTestAdd';
import Profile from './Components/Profile/profile';
import EyeTestView from './Components/Eyetest/eyeTestView';
import Prescription from './Components/Prescription';
import { useTranslation } from 'react-i18next';
import ForgotPassword from './Components/Login/forgotPassword';
import SetPassword from './Components/Login/setPassword';
import OrdersList from './Components/Orders';
import AddOrders from './Components/Orders/addOrders';
import OpticianList from './Components/Optician';
import OpticianProfile from './Components/Optician/view';
import BackOfficeList from './Components/BackOffice';
import PosList from './Components/Pos';
import PosProfile from './Components/Pos/view';
import DoctorList from './Components/Doctor';
import DoctorProfile from './Components/Doctor/view';
import BulkUpload from './Components/BulkUpload';
import PatientProfile from './Components/Patient/view';
import useIdleLogout from './hooks/useIdleLogout';
import useNavigationStack from './hooks/useNavigationStack';
import {getSecureItem, removeSecureItem } from "./utils/secureStorage";
function App() {
    const { pathname } = useLocation();

    const stack = useNavigationStack(10);

  useIdleLogout(() => {
    removeSecureItem("authToken");
    removeSecureItem("UserData");
    removeSecureItem("UserType");
    removeSecureItem("ExternalOptician");

    localStorage.removeItem("patientEmail");
    localStorage.removeItem("posListConfigCopy");
    localStorage.removeItem("opticianListConfigCopy");
    localStorage.removeItem("orderListConfigCopy");

    window.location.href = "/login";
});

// useEffect(() => {
//     if (stack.length < 2) return;

//     const currentRoute = stack[stack.length - 1];
//     const previousRoute = stack[stack.length - 2];

//     // Leaving eyetest/add → clear email
//     if (previousRoute === "/eyetest/add" && currentRoute !== "/eyetest/add") {
//         removeSecureItem("patientEmail");
//     }
// }, [stack]);
    return (
        <Routes>
            <Route index element={<Login />} />
            <Route path="login" element={<Login />} />
            <Route path="forgot-password" element={<ForgotPassword />} />
            <Route path="setpassword" element={<SetPassword />} />

            <Route element={<DashboardLayout />}>
                <Route path="*" element={<NotFound />} />
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="bulk-upload" element={<BulkUpload />} />
                <Route path="profile" element={<Profile />} />
                <Route path="prescription" element={<Prescription />} />
                <Route path="patient">
                    <Route path="list" element={<PatientList />} />
                    <Route path="view" element={<PatientProfile />} />
                </Route>
                <Route path="pos">
                    <Route path="list" element={<PosList />} />
                    <Route path="view" element={<PosProfile />} />
                </Route>
                <Route path="doctor">
                    <Route path="list" element={<DoctorList />} />
                    <Route path="view" element={<DoctorProfile />} />
                </Route>
                <Route path="optician">
                    <Route path="list" element={<OpticianList />} />
                    <Route path="view" element={<OpticianProfile />} />
                </Route>
                <Route path="backoffice">
                    <Route path="list" element={<BackOfficeList />} />
                    <Route path="view" element={<OpticianProfile />} />
                </Route>
                <Route path="email">
                    <Route path="list" element={<EmailList />} />
                </Route>
                <Route path="order">
                    <Route path="list" element={<OrdersList />} />
                    <Route path="add" element={<AddOrders />} />
                    <Route path="view" element={<AddOrders />} />
                    <Route path="edit" element={<AddOrders />} />
                </Route>
                <Route path="eyetest">
                    <Route path="list" element={<EyetestList />} />
                    <Route path="add" element={<EyeTestAdd />} />
                    <Route path="view" element={<EyeTestView />} />
                    <Route path="edit" element={<EyeTestView />} />
                </Route>
            </Route>

            {/* <Route path="concerts">
    <Route index element={<ConcertsHome />} />
    <Route path=":city" element={<City />} />
    <Route path="trending" element={<Trending />} />
  </Route> */}
        </Routes>
    );
}

export default App;
